import { useState } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import { DefaultTraceAccountForm } from "../Forms/index.js";
import Loader from "../Loader.js";
import { AnalysisAPI } from "../../api/index.js";
import { usePermissions } from "../../hooks/usePermissions";
import { useMutation } from "@tanstack/react-query";
import LoggingAPI from "../../api/logging/index.js";

export const CreateTraceAccountModal = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultFormData = {},
  ...props
}) => {
  const { currentUser } = usePermissions();
  const [submitting, setSubmitting] = useState(false);

  const create = useMutation({
    mutationFn: AnalysisAPI.Accounts.create,
    onMutate: () => setSubmitting(true),
    onSuccess: (_, variables) => {
      LoggingAPI.createLog({
        case_id: defaultFormData.case_id,
        user_id: currentUser.user_id,
        message: `Created trace account.`,
        event: "trace_account:create",
        object_type: "trace_account",
        object_uuid: variables.uuid,
      });
      onSubmit?.(defaultFormData, variables);
      onClose?.();
      setSubmitting(false);
    },
  });

  return (
    <Modal open={show} onClose={onClose} style={{ width: 550 }}>
      <Modal.Title style={{ marginBottom: 10 }}>
        Create Trace Account
      </Modal.Title>
      {!submitting && (
        <DefaultTraceAccountForm
          onSubmit={create.mutate}
          onCancel={onCancel}
          defaultFormData={defaultFormData}
          {...props}
        />
      )}
      {submitting && <Loader />}
    </Modal>
  );
};
